import { isWithinInterval, parseJSON } from "date-fns";
import { DateValuePair } from "@api";
import { addAreaValues } from "@helpers";
import { useAccountBalances } from "@api/v1/hooks/useAccountBalances";

const convertToChartData = (
  data?: DateValuePair[]
): { value: number; date: Date }[] => {
  if (!data) return [];
  return data.map(({ date, value }) => ({
    date: parseJSON(date),
    value: Math.round(value * 100) / 100,
  }));
};

interface Params {
  accountId: number;
  startDate?: Date;
  endDate?: Date;
}

export const useAccountChartData = ({
  accountId,
  startDate,
  endDate,
}: Params) => {
  const { data, isFetching, isPending } = useAccountBalances({
    accountIds: [accountId],
  });

  const convertedData = convertToChartData(data?.dateValuePairs);
  const chartData = addAreaValues(convertedData, "value");
  const chartDataInRange = chartData.filter(({ date }) => {
    if (!startDate || !endDate) return true;
    return isWithinInterval(date, { start: startDate, end: endDate });
  });

  return {
    data: chartDataInRange,
    isFetching,
    isPending,
    timeBrushData: convertedData,
  };
};
